import { Tooltip } from 'antd';
import { TFunction } from 'i18next';
import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';

import stepIcon from 'src/public/img/undraw-to-do-list.svg';

import { StepButtons } from 'src/modules/programs/components/StepButtons';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';

interface Props extends WithTranslation {
    goToPreviousStep: () => void;
    goToNextStep: () => void;
    programId: ProgramEnum;
}

class MindfulnessEmotionsPracticeStepContainer extends React.Component<Props> {
    private t: TFunction = (key, options) =>
        this.props.t(`week-4.mindfulness-emotions-practice.${key}`, options);

    public render(): JSX.Element {
        const activities: string[] = this.t('plannedActivities.activities', {
            returnObjects: true,
        });

        return (
            <>
                <S.ContentRow>
                    <S.ContentColumn md={14}>
                        <S.StepHeading small>{this.t('heading')}</S.StepHeading>
                        <S.StepHeading>{this.t('title')}</S.StepHeading>
                        <S.StepDescription small>
                            <Trans i18nKey="description.1">
                                Over the next week, whenever you notice a strong emotion track it
                                <Tooltip placement="top" title={'Comming soon'}>
                                    <S.StyledWord> here</S.StyledWord>.
                                </Tooltip>
                            </Trans>
                        </S.StepDescription>
                        <S.StepDescription small>
                            <Trans i18nKey="description.2">
                                Practice mindfulness of emotions at least once a day. You can set
                                reminders
                                <Tooltip placement="top" title={'Comming soon'}>
                                    <S.StyledWord> here</S.StyledWord>.
                                </Tooltip>
                            </Trans>
                        </S.StepDescription>
                        <S.PlannedActivitiesHolder>
                            <S.PlannedActivitiesHeading>
                                {this.t('plannedActivities.heading')}
                            </S.PlannedActivitiesHeading>
                            {activities.map((activity: string) => (
                                <S.PlannedActivity smallPadding key={activity}>
                                    <S.ActivityContent>{activity}</S.ActivityContent>
                                </S.PlannedActivity>
                            ))}
                        </S.PlannedActivitiesHolder>
                        <S.StepDescription small>{this.t('description.3')}</S.StepDescription>
                    </S.ContentColumn>
                    <S.ContentColumn md={10}>
                        <S.StepIcon large iconUrl={stepIcon} />
                    </S.ContentColumn>
                </S.ContentRow>
                <StepButtons
                    onPreviousClick={this.props.goToPreviousStep}
                    onNextClick={this.props.goToNextStep}
                    hasNextStep
                />
            </>
        );
    }
}

export const MindfulnessEmotionsPracticeStep = withTranslation('cbt')(
    MindfulnessEmotionsPracticeStepContainer,
);
